import jobs from './en/jobs.json';
import notifications from './en/notifications.json';
import profile from './en/profile.json';
import rbac from './en/rbac.json';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  jobs,
  notifications,
  profile,
  rbac,
};
